import OverlayImage from 'components/OverlayImage/OverlayImage';

export default OverlayImage;
